module.exports = __webpack_public_path__ + "static/media/icon-chevron-right.9c59704b.svg";